{
  "nav": {
    "chat": "Sesión",
    "agents": "Agentes",
    "history": "Historial",
    "files": "Archivos",
    "changes": "Cambios",
    "mailbox": "Buzón",
    "skills": "Habilidades",
    "worktrees": "Worktrees",
    "design": "Estudio de diseño",
    "officemap": "Mapa de oficinas",
    "settings": "Ajustes",
    "sddwizard": "Nuevo proyecto SDD",
    "specs": "Especificaciones",
    "sddboard": "Tablero en vivo",
    "autophase": "Fases",
    "fleet": "Flota",
    "inspector": "Inspector",
    "prompts": "Prompts"
  },
  "brand": {
    "returnToChat": "{{name}} — volver al chat",
    "returnToChatDefault": "WrongStack — volver al chat"
  },
  "status": {
    "connected": "Conectado",
    "disconnected": "Desconectado",
    "idle": "Inactivo",
    "thinking": "Pensando",
    "running": "En ejecución",
    "waiting": "En espera",
    "done": "Completado",
    "stopped": "Detenido"
  },
  "menu": {
    "moreWithHidden": "Más, {{count}} elementos ocultos",
    "moreOptions": "Más opciones",
    "moreCompactHidden": "Más — {{count}} paneles/vistas ocultos, paleta, tema, monitores",
    "moreCompact": "Más — paleta, tema, monitores",
    "moreFull": "Más — paleta, tema, atajos, monitores",
    "commandPalette": "Paleta de comandos",
    "keyboardShortcuts": "Atajos de teclado",
    "panels": "Paneles",
    "views": "Vistas",
    "theme": "Tema",
    "monitors": "Monitores",
    "fleetMonitor": "Monitor de flota",
    "agentsMonitor": "Monitor de agentes"
  },
  "sidePanel": {
    "dragHint": "Arrastra para cambiar el tamaño · doble clic para restablecer",
    "collapse": "Contraer panel (Ctrl+\\)"
  },
  "history": {
    "openDashboard": "Abrir panel de sesiones"
  },
  "agents": {
    "pending": "pendiente…",
    "empty": "Aún no hay agentes",
    "emptyHint": "Los subagentes aparecen aquí cuando la flota está activa.",
    "runningCount": "{{count}} en ejecución",
    "totalCount": "{{count}} en total",
    "openFull": "Abrir vista completa de agentes",
    "agentsLive": "AGENTES · LIVE",
    "doneCount": "{{count}} hechos",
    "failedCount": "{{count}} fallidos",
    "modelsLabel": "modelos",
    "shownLabel": "mostrados",
    "totalLabel": "total",
    "leaderFleetTotals": "(líder {{leader}} · flota {{fleet}})",
    "navHintJk": "j/k o ↑↓ para navegar",
    "escCloseDetail": "· Esc para cerrar el detalle",
    "noAgentsRunning": "Sin agentes en ejecución.",
    "contextUsage": "Uso de contexto",
    "lastToolLabel": "último:",
    "unknownSession": "Sesión desconocida",
    "sessionCopyTitle": "Sesión: {{sid}} — clic para copiar",
    "sessionWord": "sesión",
    "agentsCountSuffix_one": "{{count}} agente",
    "agentsCountSuffix_other": "{{count}} agentes",
    "sessionTitle": "Sesión: {{sid}}",
    "projectSuffix": " · Proyecto: {{name}}",
    "statusIdle": "inactivo"
  },
  "changes": {
    "fileCount_one": "{{count}} archivo",
    "fileCount_other": "{{count}} archivos",
    "refreshTitle": "Actualizar cambios",
    "loading": "Cargando cambios…",
    "clean": "Sin cambios — el árbol de trabajo está limpio.",
    "selectPrompt": "Selecciona un archivo modificado para ver su diff.",
    "unified": "Unificado",
    "unifiedTitle": "Diff unificado",
    "edit": "Editar",
    "editTitle": "Diff lado a lado editable",
    "loadingDiff": "Cargando diff…",
    "binary": "Archivo binario — diff no mostrado.",
    "tooLarge": "Archivo demasiado grande para diff."
  },
  "inspector": {
    "showPanel": "Mostrar panel Inspector (Flota / Agentes / Auditoría)",
    "hidePanel": "Ocultar panel Inspector",
    "label": "Inspector",
    "openAudit": "Abrir pestaña Auditoría",
    "tabFleet": "Flota",
    "tabAgents": "Agentes",
    "tabAudit": "Auditoría",
    "collapseAria": "Contraer panel Inspector",
    "collapseTitle": "Contraer (Esc)",
    "noAgentsActive": "Ningún agente activo",
    "agentsAppearHint": "Los agentes aparecen aquí cuando la flota está activa.",
    "selected": "{{name}} (seleccionado)"
  },
  "nextSteps": {
    "header": "Próximos pasos",
    "autoSubmitting": "envío automático en",
    "clickToFill": "clic para rellenar",
    "clickToFillTitle": "Clic para rellenar: {{text}}",
    "auto": "auto",
    "willAutoSubmit": "Envio automático tras la cuenta atrás"
  },
  "mailbox": {
    "onlineCount": "{{count}} en línea",
    "messages": "Mensajes",
    "deleteAllTitle": "Eliminar todos los mensajes",
    "deleteAll": "Eliminar todo",
    "deleting": "Eliminando…",
    "purgeTitle": "Purgar mensajes obsoletos/huérfanos",
    "purge": "Purgar",
    "purging": "Purgando…",
    "newLabel": "NUEVO",
    "empty": "Aún no hay mensajes.",
    "offlineCount": "+{{count}} sin conexión",
    "timeNow": "ahora",
    "deleteAllConfirmTitle_one": "¿Eliminar {{count}} mensaje?",
    "deleteAllConfirmTitle_other": "¿Eliminar todos los {{count}} mensajes?",
    "deleteAllConfirmBody": "El archivo del buzón se trunca para cada agente. Esto no se puede deshacer.",
    "purgeConfirmTitle": "¿Purgar mensajes obsoletos?",
    "purgeConfirmBody": "Elimina los mensajes completados de más de 1 día y los incompletos de más de 7 días. Los mensajes activos se conservan.",
    "type": {
      "note": "Nota",
      "ask": "Pregunta",
      "assign": "Asignación",
      "steer": "Dirigir",
      "btw": "Por cierto",
      "broadcast": "Difusión",
      "status": "Estado",
      "result": "Resultado"
    },
    "emptyDetail": "Ningún mensaje seleccionado",
    "emptyDetailHint": "Haz clic en un mensaje del panel Buzón para verlo aquí.",
    "readBy": "Leído por",
    "backToChat": "Volver al chat",
    "completed": "Completado",
    "everyone": "todos",
    "closeTitle": "Cerrar (Esc)",
    "replyTo": "En respuesta a: {{id}}",
    "completedBy": "Completado por {{name}}",
    "completedByAt": "Completado por {{name}} el {{time}}",
    "outcome": "Resultado:",
    "task": "Tarea:",
    "messageNotFound": "Mensaje no encontrado",
    "messageNotFoundHint": "Este mensaje puede haber sido eliminado o purgado."
  },
  "sessions": {
    "recentSessions": "Sesiones recientes",
    "deleteEmptyTitle_one": "¿Eliminar {{count}} sesión vacía?",
    "deleteEmptyTitle_other": "¿Eliminar {{count}} sesiones vacías?",
    "deleteEmptyConfirmBody": "Las sesiones sin uso de tokens se eliminan del disco.",
    "filterPlaceholder": "Filtrar por título, modelo, proveedor…",
    "clearFilter": "Borrar filtro",
    "noHistory": "Aún no hay historial",
    "noHistoryHint": "Tus conversaciones aparecerán aquí",
    "noMatches": "Sin resultados",
    "noMatchesHint": "Prueba un filtro distinto",
    "group": {
      "favorites": "Favoritos",
      "today": "Hoy",
      "yesterday": "Ayer",
      "thisWeek": "Esta semana",
      "earlier": "Anteriores"
    },
    "nicknamePlaceholder": "Apodo",
    "empty": "(vacío)",
    "resuming": "reanudando…",
    "active": "activa",
    "renameTitleNickname": "{{nickname}} — original: {{title}}",
    "renameTitle": "{{title}}\n\nDoble clic para renombrar",
    "unfavorite": "Quitar de favoritos",
    "markFavorite": "Marcar como favorito",
    "deleteSessionConfirmTitle": "¿Eliminar la sesión?",
    "deleteSessionConfirmBody": "\"{{name}}\" se eliminará del disco. Esto no se puede deshacer.",
    "deleteSessionTitle": "Eliminar sesión"
  },
  "sessionPanel": {
    "actions": {
      "abort": "Detener",
      "newSession": "Nueva sesión",
      "export": "Exportar",
      "compact": "Comprimir",
      "newSessionTitle": "Iniciar una nueva sesión (Ctrl+N)",
      "exportTitle": "Exportar el chat como markdown (Ctrl+E)",
      "compactTitle": "Comprimir la ventana de contexto",
      "clearTitle": "Borrar el contexto (Ctrl+L)"
    },
    "model": "Modelo",
    "modelTitle": "Cambiar de modelo (Ctrl+M)",
    "context": "Contexto",
    "contextTitle": "Haz clic para un desglose del contexto",
    "sessionLabel": "Sesión",
    "stats": {
      "messages": "Mensajes",
      "elapsed": "Transcurrido",
      "tokens": "Tokens",
      "cost": "Coste",
      "iteration": "Iteración",
      "agents": "Agentes",
      "tokensSub": "{{in}} entra / {{out}} sale",
      "iterationOf": "de {{max}}",
      "agentsRunning": "{{count}} en ejecución"
    },
    "plan": "Plan",
    "planComplete": "{{pct}}% completado",
    "pinned": "Fijados",
    "quickSettings": "Ajustes rápidos",
    "autonomy": "Autonomía",
    "autonomyOptions": {
      "off": "Desactivado",
      "suggest": "Sugerir",
      "auto": "Auto",
      "eternal": "Perpetuo",
      "eternal-parallel": "Perpetuo Paralelo"
    },
    "yolo": "Modo YOLO",
    "yoloTitle": "Omitir los diálogos de confirmación de herramientas",
    "refine": "Refinar prompts",
    "refineTitle": "Reescribir los prompts antes de enviar",
    "sound": "Sonido al completar",
    "soundTitle": "Reproducir un suave tono al terminar una ejecución",
    "sessionId": "sesión {{id}}"
  },
  "fleet": {
    "status": {
      "running": "en ejecución",
      "done": "hecho",
      "failed": "fallido",
      "timeout": "tiempo agotado",
      "stopped": "detenido"
    },
    "leader": "líder",
    "providerModel": "Proveedor / Modelo",
    "elapsed": "Transcurrido",
    "running": "en ejecución…",
    "iterations": "Iteraciones",
    "toolCalls": "Llamadas",
    "cost": "Coste",
    "budgetExtensions": "Ampliaciones de presupuesto",
    "activity": "Actividad",
    "budgetWarning": "aviso de presupuesto",
    "contextWindow": "Ventana de contexto",
    "tokensUsed": "{{used}} / {{max}} tokens",
    "toolRunning": "en ejecución…",
    "lastTool": "última herramienta",
    "error": "Error",
    "finalOutput": "Salida final",
    "copyOutput": "Copiar salida",
    "liveOutput": "Salida en vivo",
    "waitingOutput": "Esperando salida…",
    "outputHint": "La salida aparece aquí a medida que el agente transmite texto.",
    "toolLog": "Registro de herramientas ({{count}} llamadas)",
    "fail": "fallo",
    "moreTools": "+{{count}} herramientas más",
    "cardRunning": "en ejecución {{tool}}",
    "cardLastTool": "última: {{tool}}",
    "contextPercent": "Contexto {{pct}}%",
    "doneCount": "{{count}} hechos",
    "errCount": "{{count}} err",
    "statusRunning": "en ejecución",
    "statusDone": "completado",
    "statusFailed": "fallido",
    "statusTimeout": "tiempo agotado",
    "statusStopped": "detenido",
    "sessionPrefix": "sesión:",
    "currentTask": "Tarea actual",
    "performance": "Rendimiento",
    "uniqueTools": "Herramientas únicas",
    "avgPerTool": "media {{ms}}ms por herramienta",
    "context": "Contexto",
    "tokens": "Tokens",
    "ctxUsed": "{{pct}}% usado",
    "completed": "completado",
    "budgetWarningTitle": "⚡ Aviso de presupuesto",
    "hittingLimit": "Alcanza el límite {{kind}} ({{used}}/{{limit}})",
    "hittingLimitTitle": "⚡ alcanza el límite {{kind}} ({{used}}/{{limit}})",
    "budgetExt_one": "{{count}} extensión de presupuesto",
    "budgetExt_other": "{{count}} extensiones de presupuesto",
    "extendedTimes_one": "El agente amplió su presupuesto {{count}} vez por tareas largas",
    "extendedTimes_other": "El agente amplió su presupuesto {{count}} veces por tareas largas",
    "errorLabel": "Error",
    "failureReason": "Motivo de fallo",
    "failed": "Fallido",
    "fleetMonitor": "MONITOR DE FLOTA",
    "runningCount": "{{count}} en ejecución",
    "totalAgents_one": "{{count}} agente en total",
    "totalAgents_other": "{{count}} agentes en total",
    "noLeader": "sin líder",
    "closeFleet": "Cerrar monitor de flota",
    "colName": "Nombre",
    "colStatus": "Estado",
    "colActivity": "Actividad",
    "colIters": "Iter.",
    "colTools": "Herram.",
    "colCost": "Coste",
    "colCtx": "CTX",
    "colExt": "Ext.",
    "colReason": "Motivo",
    "noAgentsActive": "Sin agentes activos",
    "agentsAppear": "Los agentes aparecen aquí cuando la flota está activa.",
    "agentTimeline": "Cronología de agentes",
    "noAgentEvents": "Aún no hay eventos de conversación de agentes.",
    "navHint": "↑↓ navegar",
    "selectDetailHint": "↵ seleccionar detalle",
    "escHint": "Esc deseleccionar / cerrar",
    "detailedView": "vista detallada",
    "closeBtn": "✕ cerrar",
    "selectAgentDetail": "Selecciona un agente para información detallada",
    "selectAgentBody": "Haz clic en un agente de la lista para métricas detalladas, registros, salida en streaming y más — similar a la vista detallada del historial.",
    "navigateWord": "navegar",
    "selectWord": "seleccionar",
    "deselectWord": "deseleccionar"
  },
  "context": {
    "wsNotConnected": "WebSocket no conectado",
    "noData": "No se recibieron datos de depuración. El servidor podría no admitir depuración de contexto.",
    "title": "Desglose del contexto",
    "windowUsage": "Uso de ventana",
    "contextMode": "Modo de contexto",
    "fetching": "Obteniendo el desglose del contexto…",
    "systemPrompt": "Prompt del sistema",
    "tools": "Herramientas",
    "messages": "Mensajes",
    "tokenAllocation": "Asignación de tokens",
    "systemTitle": "Sistema: {{tokens}}",
    "toolsTitle": "Herramientas: {{tokens}}",
    "messagesTitle": "Mensajes: {{tokens}}",
    "system": "Sistema",
    "toolBreakdown": "Desglose de herramientas",
    "messagesSummary": "Mensajes ({{count}}) — {{total}} tok",
    "barWithTokens": "Ventana de contexto: {{tokens}} / {{max}} tokens ({{pct}})",
    "barPct": "Ventana de contexto: {{pct}}",
    "barClick": " — clic para el desglose"
  },
  "refine": {
    "header": "✨ Refinar prompt",
    "autoSend": "envío automático en {{count}} s",
    "cancelTitle": "Cancelar (Esc)",
    "editLabel": "Editar el prompt refinado:",
    "editPlaceholder": "Editar el prompt refinado...",
    "useEdit": "Usar edición",
    "original": "Original",
    "refined": "Refinado",
    "yourLanguage": "(tu idioma)",
    "refinedTitle": "Haz clic o pulsa Intro para usar esta versión",
    "english": "Inglés",
    "englishTitle": "Pulsa e para la versión en inglés",
    "hintRefined": "refinado",
    "hintEnglish": "Inglés",
    "hintOriginal": "original",
    "hintEdit": "editar",
    "edit": "Editar",
    "useRefined": "Usar refinado"
  },
  "specs": {
    "heading": "Especificaciones",
    "subtitle": "Ver y gestionar el desarrollo guiado por especificaciones",
    "empty": "No se encontraron specs. Usa {{command}} para crear una.",
    "tasks": "Tareas ({{count}})",
    "doneCount": "{{count}} hechas",
    "runningCount": "{{count}} en ejecución",
    "pendingCount": "{{count}} pendientes",
    "runTitle": "Ejecutar esta spec como un tablero AutoPhase en vivo",
    "run": "Ejecutar",
    "list": "Lista",
    "graph": "Grafo",
    "loadingTasks": "Cargando tareas…"
  },
  "refresh": {
    "heading": "Verificador de resiliencia F5",
    "subtitle": "Confirma que la última sesión activa, la transcripción y el estado de la UI sobreviven a una recarga de página. Abre esta vista y pulsa F5 — cada fila verde debe seguir verde.",
    "recordProbe": "Registrar sonda",
    "latestSession": "Última sesión activa",
    "restoredLocal": "Restaurado desde localStorage",
    "sessionIdExtra": "id de sesión: {{id}}",
    "noSessionYet": "todavía no se ha iniciado ninguna sesión",
    "activePointer": "Puntero de sesión activa",
    "lastVisited": "marca de tiempo lastVisitedAt",
    "never": "nunca",
    "persistedEnv": "Entorno persistido",
    "transcriptRehydrate": "Rehidratación de transcripción",
    "localTranscript": "Transcripción local recuperada",
    "messagesExtra": "{{count}} mensajes, {{queued}} en cola",
    "noMessages": "0 mensajes",
    "noBleed": "Sin fuga entre sesiones",
    "bleedExtra": "ligado={{bound}} vs activo={{active}}",
    "transcriptBinds": "la transcripción se liga a la sesión activa",
    "uiWorkspace": "Espacio de trabajo UI",
    "noneValue": "(ninguno)",
    "payloadSize": "Carga de localStorage (4 claves): {{count}} caracteres",
    "probeLog": "Registro de sondas",
    "noProbes": "Aún no hay sondas — pulsa el botón \"Registrar sonda\" arriba, o F5 en esta vista, para registrar una comprobación de rehidratación.",
    "simulatedF5": "F5 simulado: reejecutar persist rehydrate"
  },
  "board": {
    "status": {
      "pending": "Pendiente",
      "in_progress": "En progreso",
      "review": "Revisión",
      "failed": "Fallido",
      "completed": "Hecho",
      "queued": "En cola",
      "blocked": "Bloqueado",
      "cancelled": "Cancelado"
    },
    "newTaskTitle": "Nueva tarea",
    "newTaskPlaceholder": "Título de tarea…",
    "addTask": "Añadir tarea",
    "empty": "Aún no hay fases — inicia una ejecución AutoPhase para rellenar el tablero.",
    "summary": "{{phases}} fases · {{tasks}} tareas",
    "phases": "Fases",
    "statusTab": "Estado",
    "dropHere": "Suelta las tareas aquí",
    "emptySpec": "Aún no hay tareas en esta spec.",
    "depGraphHeading": "Grafo de dependencias",
    "worktreePrefix": "worktree: {{branch}}"
  },
  "debug": {
    "trendUp": "Aumentando",
    "trendDown": "Disminuyendo",
    "trendStable": "Estable",
    "heading": "Panel de depuración",
    "subtitle": "Monitorización en tiempo real para WrongStack WebUI",
    "refreshLabel": "Actualizar:",
    "lastUpdated": "Última actualización: {{time}}",
    "fetchFailed": "Error al obtener las métricas",
    "fileWatcher": "Observador de archivos",
    "watcherStatus": "Estado del observador",
    "running": "En ejecución",
    "stopped": "Detenido",
    "activeProjects": "Proyectos activos",
    "projectsWatched": "Proyectos observados",
    "fileChanges": "Cambios de archivos",
    "totalDetected": "Total detectado",
    "filesProcessed": "Archivos procesados",
    "afterHash": "Tras filtro hash",
    "broadcastsSent": "Difusiones enviadas",
    "toClients": "A clientes WebUI",
    "debounceResets": "Reinicios de antirrebote",
    "rapidWrites": "Escrituras rápidas sucesivas",
    "avgDebounce": "Retardo antirrebote medio",
    "actualDelay": "Retardo real aplicado",
    "totalDelay": "Retardo total",
    "sumDelays": "Suma de todos los retardos",
    "browserPerf": "Rendimiento del navegador",
    "heapUsed": "Memoria usada",
    "jsHeap": "Memoria JavaScript",
    "heapTotal": "Memoria total",
    "totalHeap": "Tamaño total de memoria",
    "pageUptime": "Tiempo de actividad",
    "sinceLoad": "Desde la carga",
    "rawData": "Datos sin procesar"
  },
  "providerModels": {
    "using": "En uso",
    "noModelPicked": "(ningún modelo elegido)",
    "clearAllowlist": "Borrar lista permitida",
    "clearAllowlistAria": "Borrar la lista permitida guardada para {{provider}}",
    "refresh": "Actualizar del servidor",
    "refreshAria": "Actualizar la lista de modelos para {{provider}}",
    "probing": "Comprobando…",
    "use": "Usar",
    "useModelAria": "Usar el modelo {{model}} para {{provider}}",
    "differsHint": "La lista comprobada difiere de la lista guardada — vuelve a ejecutar {{command}} para persistir."
  },
  "dock": {
    "expandChip": "Expandir {{label}}",
    "collapseChip": "Contraer {{label}}",
    "ahead": "{{count}} por delante",
    "behind": "{{count}} por detrás",
    "linesAdded": "{{count}} líneas añadidas",
    "linesDeleted": "{{count}} líneas eliminadas",
    "untrackedFiles": "{{count}} archivos sin rastrear",
    "customizeTitle": "Personalizar chips del dock",
    "dockChips": "Chips del dock",
    "noActiveGoal": "Ningún objetivo activo",
    "noActiveGoalDetail": "Inicia un objetivo desde el chat o el comando goal."
  },
  "agentsMonitor": {
    "leaderBadge": "LÍDER",
    "iters": "Iter.",
    "tools": "Herramientas",
    "activityBins": "Actividad (12 contenedores)",
    "streamingOutput": "Salida en streaming",
    "recentTools": "Herramientas recientes",
    "finalOutput": "Salida final",
    "heading": "Monitor de agentes",
    "prevAgent": "Agente anterior",
    "nextAgent": "Agente siguiente",
    "closeAria": "Cerrar monitor de agentes",
    "hintPage": "←→ página",
    "hintNavigate": "↑↓ navegar lista",
    "hintEsc": "Esc cerrar"
  },
  "terminal": {
    "resize": "Cambiar tamaño de terminales",
    "labelSingular": "Terminal",
    "labelPlural": "Terminales",
    "projectShell": "Shell del proyecto",
    "maxTerminals": "Máximo {{count}} terminales",
    "newTerminal": "Nuevo terminal",
    "restart": "Reiniciar terminal activo",
    "closeAll": "Cerrar todos los terminales",
    "closeDock": "Cerrar el dock de terminal (Ctrl+`)",
    "closeTab": "Cerrar {{name}}",
    "processExited": "[proceso terminado con código {{code}}]"
  },
  "sessionWatch": {
    "liveStream": "Transmisión en vivo",
    "events_one": "{{count}} evento",
    "events_other": "{{count}} eventos",
    "interruptTitle": "Detener cooperativamente a este agente en su próximo paso (no es un kill)",
    "interrupt": "⏸ Interrumpir",
    "interrupting": "…",
    "loading": "Cargando sesión…",
    "done": "✓✓ hecho",
    "read": "✓ leído",
    "delivered": "⏳ entregado",
    "agent": "Agente",
    "you": "Tú",
    "working": "{{name}} · trabajando",
    "claude": "Claude",
    "priority": "Prioridad",
    "placeholder": "{{label}} → esta sesión…",
    "send": "Enviar",
    "sendHint": "⌘/Ctrl+Enter para enviar · visible en la próxima iteración del agente",
    "msgType": {
      "steerLabel": "🔄 Dirigir",
      "steerHint": "Ajustar el comportamiento durante la tarea",
      "askLabel": "❓ Preguntar",
      "askHint": "Pregunta — espera respuesta",
      "assignLabel": "📋 Asignar",
      "assignHint": "Una tarea en la que actuar",
      "noteLabel": "💬 Nota",
      "noteHint": "Para tu información, no urgente"
    },
    "sentRunning": "Entregado — el agente en ejecución lo verá en su próximo paso",
    "sentIdle": "Entregado — el objetivo está inactivo; aparece en su buzón, leído en su próxima ejecución",
    "sentFailed": "Falló: {{error}}",
    "interruptReason": "El operador solicitó la detención desde Fleet HQ",
    "interruptSent": "Interrupción enviada — el agente se detiene en su próximo paso (no es un kill)",
    "interruptFailed": "Interrupción fallida: {{error}}"
  },
  "sideEffects": {
    "empty": "Aún no se han registrado efectos secundarios.",
    "emptyHint": "Los comandos bash, las instalaciones de paquetes y las solicitudes de red aparecerán aquí.",
    "heading": "Efectos secundarios",
    "exportTitle": "Exportar los efectos secundarios filtrados como CSV",
    "all": "Todos",
    "colTime": "Hora",
    "colTool": "Herramienta",
    "colRisk": "Riesgo",
    "colDetail": "Detalle",
    "colOutcome": "Resultado"
  },
  "monitor": {
    "elapsedHm": "hace {{h}}h {{m}}m",
    "elapsedMs": "hace {{m}}m {{s}}s",
    "elapsedS": "hace {{s}}s",
    "heading": "Monitor de flota",
    "clientsHeading": "Clientes conectados",
    "terminal": "Terminal",
    "webui": "IU Web",
    "repl": "REPL",
    "totalConnected": "conectados en total",
    "mailQueue": "Cola de correo",
    "total": "Total",
    "open": "Abiertos",
    "unread": "No leídos",
    "agents": "Agentes",
    "messagesSub": "mensajes",
    "uncompletedSub": "sin completar",
    "waitingSub": "en espera",
    "ofTotal": "de {{count}} en total",
    "agentRoster": "Lista de agentes",
    "liveMailActivity": "Actividad de correo en vivo",
    "noActivity": "Sin actividad reciente",
    "mailboxAgents": "Agentes del buzón",
    "noMailboxAgents": "Ningún agente registrado",
    "moreCount": "+{{count}} más",
    "agentFallback": "agente",
    "fleetAgents": "Agentes de la flota",
    "noFleetAgents": "Ningún agente de flota en ejecución",
    "iter": "iter.",
    "mailType": {
      "sent": "Enviado",
      "delivered": "Entregado",
      "read": "Leído",
      "completed": "Completado"
    }
  },
  "sdd": {
    "status": {
      "pending": "pendiente",
      "queued": "en cola",
      "in_progress": "en ejecución",
      "blocked": "bloqueado",
      "review": "revisión",
      "failed": "fallido",
      "completed": "hecho",
      "cancelled": "cancelado"
    },
    "activityHeading": "Actividad",
    "feedEmpty": "Aún nada — los eventos aparecen aquí a medida que los agentes toman y completan tareas.",
    "destroyTitle": "¿Destruir el proyecto SDD?",
    "destroyDesc": "Esto borra el run y su trabajo. No se puede deshacer (el revert opcional preserva el historial).",
    "stopRun": "Detener el run",
    "stopRunAgents_one": "Detener el run ({{count}} agente activo)",
    "stopRunAgents_other": "Detener el run ({{count}} agentes activos)",
    "removeWorktreesAll": "Eliminar todos los worktrees git + ramas wstack/ap/* — incluido el trabajo sin mergear",
    "removeWorktreesCount_one": "Eliminar {{count}} worktree git + ramas wstack/ap/* — incluido el trabajo sin mergear",
    "removeWorktreesCount_other": "Eliminar {{count}} worktrees git + ramas wstack/ap/* — incluido el trabajo sin mergear",
    "deleteArtifacts": "Eliminar todos los artefactos SDD (specs, grafo de tareas, board, sesión)",
    "revertMerged_one": "Revertir también {{count}} commit mergeado",
    "revertMerged_other": "Revertir también {{count}} commits mergeados",
    "revertHint": "Añade commits de revert (historial preservado). Se rechaza si el árbol de trabajo está sucio.",
    "baseBranchFallback": "la rama base",
    "noteLeaveMerged": "Los commits mergeados quedarán en la rama base. Marca la casilla de arriba para deshacerlos también.",
    "noteAbandon": "Asegúrate de que realmente quieres abandonar este run.",
    "destroying": "Destruyendo…",
    "destroyAll": "Destruir todo",
    "kanbanBacklog": "Backlog",
    "kanbanReady": "Listo",
    "kanbanRunning": "En ejecución",
    "kanbanReview": "Revisión",
    "kanbanFailed": "Fallido",
    "kanbanDone": "Completado",
    "kanbanEmpty": "vacío"
  },
  "toolResult": {
    "collapseToLines": "Contraer a las primeras {{count}} líneas",
    "showAllLines": "Mostrar las {{total}} líneas ({{more}} más)",
    "exitCode": "código de salida:",
    "jsonLines": "JSON · {{count}} líneas",
    "collapse": "contraer",
    "expand": "expandir"
  },
  "design": {
    "heading": "Design Studio — Galería",
    "kitsCount": "{{count}} kits",
    "searchPlaceholder": "Buscar kits…",
    "stackTitle": "Stack para Use + Materialize",
    "wrote": "Escrito {{path}}",
    "materializeFailed": "Materialize falló: {{error}}",
    "verifyError": "Verificar: {{error}}",
    "verifyOffPalette": "Verificar: {{pct}}% en paleta — {{count}} fuera de paleta en {{files}} archivo(s)",
    "verifyClean": "Verificar: limpio ✓ ({{files}} archivo(s) en paleta)",
    "writing": "Escribiendo archivo de tema…",
    "scanning": "Escaneando archivos de UI…",
    "active": "Activo",
    "reapply": "Reaplicar",
    "use": "Usar",
    "materializeTitle": "Escribir tokens en un archivo de tema {{stack}}",
    "materialize": "Materializar",
    "verifyTitle": "Escanear archivos de UI en busca de colores fuera de paleta",
    "verify": "Verificar",
    "colors": "Colores"
  },
  "autoPhase": {
    "summary_one": "{{count}} fase · {{pct}}% completado",
    "summary_other": "{{count}} fases · {{pct}}% completado",
    "switchBoard": "Cambiar tablero",
    "boardsCount_one": "{{count}} tablero…",
    "boardsCount_other": "{{count}} tableros…",
    "toggleAutonomousTitle": "Activar/desactivar modo autónomo",
    "autonomous": "Autónomo",
    "manual": "Manual",
    "resumeTitle": "Reanudar la ejecución",
    "pauseTitle": "Pausar la ejecución",
    "resume": "Reanudar",
    "pause": "Pausar",
    "stopTitle": "Detener la ejecución — aborta los agentes en vuelo inmediatamente",
    "stop": "Detener",
    "newTitle": "Limpiar este tablero e iniciar una nueva ejecución AutoPhase",
    "newLabel": "Nuevo",
    "revertConfirm": "¿Revertir los commits de la ejecución?",
    "revertTitle": "Deshacer esta ejecución — git-revert de los commits y eliminar sus worktrees",
    "revert": "Revertir",
    "goal": "Objetivo",
    "planning": "Planificando fases…",
    "planningBody": "Tu objetivo fue recibido. WrongStack lo desglosa en fases y tareas — el tablero aparece aquí en cuanto el plan está listo.",
    "startHeading": "Iniciar un plan de fases",
    "startBody": "Describe lo que quieres construir. WrongStack planificará fases y tareas, luego las ejecutará — observa y dirige la ejecución en el tablero.",
    "startPlaceholder": "p.ej. Crea una API REST de gestión de usuarios con Express y SQLite...",
    "isolateLabel": "Aislar cada fase en su propio worktree de git",
    "startButton": "Iniciar AutoPhase",
    "ctrlHint": "Ctrl+Enter para iniciar",
    "isolateOn": "las fases se ejecutan en worktrees aislados, fusionados con squash",
    "isolateOff": "las fases se ejecutan directamente en la rama actual",
    "lanes": "Carriles",
    "graph": "Grafo",
    "planningAck": "🚀 **AutoPhase** — entendido. Planificando fases para tu objetivo…"
  },
  "collab": {
    "noObservers": "Sin observadores en vivo",
    "observerTitle": "Unirse como observador de solo lectura (Fase 1)",
    "observerRole": "observador",
    "annotatorTitle": "Unirse como anotador — deja notas en las llamadas (Fase 2)",
    "annotatorRole": "anotador",
    "controllerTitle": "Unirse como controlador — puede pausar el agente (Fase 3)",
    "controllerRole": "controlador",
    "errorPrefix": "Collab: {{error}}",
    "dismiss": "cerrar",
    "observers_one": "{{count}} observador",
    "observers_other": "{{count}} observadores",
    "annotationsTitle": "{{count}} anotación(es) abierta(s) — anotadores revisando",
    "notes_one": "{{count}} nota",
    "notes_other": "{{count}} notas",
    "pausedTitle": "El agente está en pausa — un controlador está revisando",
    "paused": "en pausa",
    "joinedTitle": "Se unió {{time}}",
    "grantTitle": "Ceder control — promocionar a este participante a controlador",
    "injectTitle": "Inyectar un resultado sintético para una llamada en curso",
    "inject": "Inyectar",
    "resumeTitle": "Reanudar el agente",
    "resume": "Reanudar",
    "pauseTitle": "Pausar el agente antes de la próxima llamada",
    "pauseAgent": "Pausar agente",
    "leaveTitle": "Salir de la sesión de observación",
    "leave": "Salir",
    "injectToolResult": "Inyectar resultado",
    "close": "cerrar",
    "targetTool": "id tool_use objetivo",
    "targetPlaceholder": "elige una llamada en curso o escribe un id tool_use",
    "toolFallback": "herramienta",
    "noPendingTools": "Sin llamadas en curso — escribe un id tool_use o pausa el agente primero.",
    "resultContent": "Contenido del resultado",
    "resultPlaceholder": "Resultado sintético dado al agente en lugar de ejecutar la herramienta",
    "markError": "marcar como error",
    "reasonPlaceholder": "razón (registro de auditoría)",
    "queueInjection": "Encolar inyección",
    "controllerInjection": "inyección controlador"
  },
  "connection": {
    "reconnecting": "Reconectando al backend (intento {{attempt}}) — reintentando en {{remaining}} s",
    "disconnected": "Desconectado del backend",
    "retry": "Reintentar ahora",
    "retryTitle": "Reintentar conexión ahora",
    "dismissTitle": "Cerrar (el chip de la barra superior sigue mostrando el estado)"
  },
  "mode": {
    "modePrefix": "modo:",
    "activeTitle": "Modo activo",
    "heading": "Modo",
    "defaultName": "Predeterminado",
    "defaultDesc": "Comportamiento estándar del agente"
  },
  "cost": {
    "clickTitle": "Haz clic para el desglose de costes por turno",
    "heading": "Desglose de costes",
    "noPricing": "Sin tarifa para el modelo actual — los valores de coste son cero.",
    "noTurns": "Aún no hay turnos completados. Ejecuta un prompt para ver el coste por turno aquí.",
    "topExpensive_one": "Turno más caro",
    "topExpensive_other": "Los {{count}} turnos más caros"
  },
  "model": {
    "runDefault": "Predeterminado del run",
    "useRunDefault": "Usar predeterminado del run",
    "filterPlaceholder": "Filtrar modelos…",
    "loading": "Cargando modelos…",
    "noMatch": "Sin coincidencias"
  },
  "modelSwitcher": {
    "filterPlaceholder": "Filtrar proveedores y modelos…",
    "noSavedProviders": "Sin proveedores guardados — registra primero una clave en Ajustes.",
    "active": "activo"
  },
  "work": {
    "todos": "Por hacer",
    "tasks": "Tareas",
    "plan": "Plan"
  },
  "todos": {
    "toggleAria": "Alternar: {{content}}",
    "removeTitle": "Eliminar tarea",
    "removeAria": "Eliminar \"{{content}}\"",
    "completedCount_one": "{{count}} completada",
    "completedCount_other": "{{count}} completadas"
  },
  "task": {
    "start": "Iniciar",
    "complete": "Completar",
    "retry": "Reintentar",
    "assign": "Asignar",
    "assignTitle": "Asignar agente",
    "unassigned": "Sin asignar",
    "statusPending": "Pendiente",
    "statusInProgress": "En curso",
    "statusBlocked": "Bloqueado",
    "statusFailed": "Fallido",
    "statusReview": "Revisión",
    "statusDone": "Completado",
    "startTitle": "Iniciar",
    "completeTitle": "Completar",
    "fail": "Fallar",
    "failTitle": "Marcar como fallido",
    "boardCount": "{{total}} tareas · {{done}} completadas"
  },
  "toolGroup": {
    "toolCalls_one": "{{count}} llamada",
    "toolCalls_other": "{{count}} llamadas"
  },
  "fileRef": {
    "removeTitle": "Eliminar referencia",
    "linesCount_one": "{{count}} línea",
    "linesCount_other": "{{count}} líneas"
  },
  "plan": {
    "statusOpen": "Abierto",
    "statusInProgress": "En curso",
    "statusDone": "Completado",
    "startTitle": "Iniciar",
    "doneTitle": "Marcar como completado",
    "reopenTitle": "Reabrir",
    "reopen": "Reabrir"
  },
  "filePicker": {
    "heading": "@ Archivos",
    "noMatch": "Ningún archivo coincide con \"{{query}}\"",
    "searching": "Buscando en el proyecto…"
  },
  "toast": {
    "dismiss": "Cerrar"
  },
  "search": {
    "placeholder": "Buscar en el chat…",
    "prevHit": "Coincidencia anterior",
    "nextHit": "Coincidencia siguiente",
    "close": "Cerrar (Esc)"
  },
  "phase": {
    "statusPending": "Pendiente",
    "statusReady": "Listo",
    "statusRunning": "En ejecución",
    "statusPaused": "En pausa",
    "statusCompleted": "Completado",
    "statusFailed": "Fallido",
    "statusSkipped": "Omitido",
    "heading": "Fases",
    "autonomousOn": "● Autónomo",
    "autonomousOff": "○ Manual",
    "autonomousOnTitle": "Modo autónomo activo — clic para pausar",
    "autonomousOffTitle": "Modo manual — clic para activar el autónomo",
    "overallProgress": "Progreso general",
    "tasksSuffix": "{{done}}/{{total}} tareas",
    "agentsSuffix_one": "{{count}} agente",
    "agentsSuffix_other": "{{count}} agentes"
  },
  "ctxMode": {
    "triggerTitle": "Modo de ventana de contexto",
    "ctxPrefix": "ctx:",
    "opsHeading": "Operaciones de contexto",
    "compactNow": "Compactar ahora",
    "compactNowDesc": "Elidir salida de herramienta antigua",
    "compactAggressive": "Compactación agresiva",
    "compactAggressiveDesc": "Elisión máxima ahora",
    "repairContext": "Reparar contexto",
    "repairDesc": "Corregir bloques tool-use huérfanos",
    "debugContext": "Depurar contexto",
    "debugDesc": "Desglose de tamaño por sección",
    "windowHeading": "Ventana de contexto",
    "keepElide": "mantener {{k}} recientes · elidir {{t}}+ tokens",
    "fallbackName": "Equilibrado",
    "fallbackDesc": "Compacción rolling por defecto"
  },
  "transcript": {
    "kindAssistant": "Asistente",
    "kindThinking": "Pensando",
    "kindToolCall": "Llamada de herramienta",
    "kindToolResult": "Resultado de herramienta",
    "kindError": "Error",
    "kindStatus": "Estado",
    "kindSystem": "Sistema",
    "title": "Historial del chat",
    "copyTitle": "Copiar historial de chat del agente",
    "empty": "Aún no hay historial de chat para este agente."
  },
  "autonomy": {
    "heading": "Modo de autonomía",
    "titlePrefix": "Autonomía: {{label}}",
    "descOff": "Control manual total — el agente espera tu entrada.",
    "descSuggest": "El agente sugiere los siguientes pasos pero espera aprobación.",
    "descAuto": "El agente continúa automáticamente tras una breve espera de confirmación.",
    "descEternal": "El agente funciona de forma autónoma hasta completar el objetivo.",
    "descEternalParallel": "Ejecución autónoma multi-agente — modo flota."
  },
  "queue": {
    "heading": "Cola de mensajes",
    "subtitle": "{{count}} en cola · mensajes enviados antes de que el agente termine",
    "btwTitle": "Por cierto — enviado como seguimiento sin interrumpir el agente en ejecución",
    "steerTitle": "Guiar — interrumpe el agente en ejecución y lo redirige con este mensaje",
    "queueTitle": "En cola — retenido hasta que termine el run del agente, luego enviado en orden",
    "sortNewestTitle": "Ordenado del más reciente — clic para ordenar del más antiguo",
    "sortOldestTitle": "Ordenado del más antiguo — clic para ordenar del más reciente",
    "newest": "Más reciente",
    "oldest": "Más antiguo",
    "clear": "Vaciar",
    "clearTitle": "Borrar todos los mensajes en cola",
    "closeTitle": "Cerrar",
    "emptyTitle": "La cola está vacía",
    "emptyBody": "Usa los botones btw / steer / añadir a cola junto a la entrada para añadir mensajes. Los elementos en cola se envían en orden cuando termina el run del agente.",
    "removeTitle": "Quitar de la cola",
    "footer": "Los mensajes se envían en orden de llegada cuando termina el run del agente. Usa el orden para ver los más recientes primero."
  },
  "checkpoint": {
    "heading": "Puntos de control de sesión",
    "countSuffix_one": "{{count}} punto de control",
    "countSuffix_other": "{{count}} puntos de control",
    "description": "Rebobina la sesión a cualquier punto de control. Los mensajes y cambios de archivos revierten a ese punto — el LLM continúa desde allí como si nada hubiera pasado después.",
    "emptyTitle": "Aún no hay puntos de control",
    "emptyBody": "Los puntos de control se crean automáticamente cada vez que envías un mensaje. Envía algunos mensajes y vuelve.",
    "latest": "reciente",
    "msgSuffix_one": "{{count}} msg",
    "msgSuffix_other": "{{count}} msgs",
    "footerPre": "Clic en cualquier punto de control para rebobinar",
    "footerPost": "para cerrar"
  },
  "goal": {
    "statusActive": "Activo",
    "statusPaused": "En pausa",
    "statusDone": "Completado",
    "statusFailed": "Fallido",
    "statusAbandoned": "Abandonado",
    "heading": "Objetivo",
    "refined": "Refinado",
    "progress": "Progreso",
    "iterations": "iteraciones",
    "deliverables": "Entregables",
    "recentActivity": "Actividad reciente"
  },
  "worktree": {
    "cleanTitle_one": "¿Limpiar {{count}} worktree huérfano?",
    "cleanTitle_other": "¿Limpiar {{count}} worktrees huérfanos?",
    "cleanMessage": "Elimina a la fuerza cada worktree git + rama wstack/ap sobrante de runs anteriores. El trabajo sin mergear en ellos se pierde.",
    "cleanConfirm": "Limpiar huérfanos",
    "orphanCount_one": "{{count}} worktree huérfano de runs anteriores",
    "orphanCount_other": "{{count}} worktrees huérfanos de runs anteriores",
    "andMore": "…y {{count}} más",
    "cleanButtonTitle": "Eliminar a la fuerza todos los worktrees + ramas huérfanos",
    "removed_one": "✓ {{count}} worktree huérfano eliminado.",
    "removed_other": "✓ {{count}} worktrees huérfanos eliminados.",
    "cleanupFailed": "limpieza fallida",
    "lanesHeading": "Worktrees",
    "base": "base",
    "isolatedCount_one": "{{count}} aislado",
    "isolatedCount_other": "{{count}} aislados",
    "statusAllocating": "asignando",
    "statusActive": "activo",
    "statusCommitting": "commitiendo",
    "statusMerging": "mergeando",
    "statusMerged": "mergeado",
    "statusConflict": "conflicto",
    "statusFailed": "fallido",
    "conflictBadge": "CONFLICTO",
    "graphAria": "Grafo de ramas worktree desde {{base}}",
    "mergedLabel": "✓ mergeado → {{base}}"
  },
  "process": {
    "heading": "Procesos en ejecución",
    "subtitle": "{{active}} activos · {{total}} total",
    "killAll": "Matar todos",
    "emptyTitle": "Sin procesos rastreados",
    "emptyBody": "Los procesos aparecen aquí cuando el agente ejecuta herramientas bash o exec. Los procesos activos muestran un LED pulsante.",
    "pidLabel": "PID {{pid}}",
    "protected": "protegido",
    "protectedTitle": "Protegido — sobrevive a kill/killAll",
    "killTitle": "Matar PID {{pid}}"
  },
  "diff": {
    "tooLarge": "Diff omitido (archivo demasiado grande para mostrar en línea)."
  },
  "fallback": {
    "placeholder": "Añadir modelo de respaldo…",
    "emptyHint": "Se prueban en orden cuando el modelo principal limita o se atasca.",
    "moveUp": "Subir",
    "moveDown": "Bajar",
    "manualPlaceholder": "proveedor/modelo",
    "addTitle": "Añadir referencia de modelo"
  },
  "liveSessions": {
    "loading": "Cargando sesiones...",
    "apiUnavailable": "API de sesión no disponible:",
    "empty": "Sin sesiones en vivo. Abre otra instancia wstack para verla aquí.",
    "heading": "Sesiones en vivo ({{count}})",
    "autoRefresh": "actualización cada 5 s",
    "pidLabel": "PID {{pid}}",
    "agentMeta": "{{iter}} iter · {{tools}} herramientas · {{ago}}",
    "andMore": "... y {{count}} más",
    "noAgents": "Sin agentes"
  },
  "monacoDiff": {
    "applyTitle": "Escribir la versión editada al disco",
    "applying": "Aplicando…",
    "applied": "Aplicado",
    "apply": "Aplicar"
  },
  "errorBody": {
    "showStack_one": "Mostrar rastreo de pila ({{count}} marco)",
    "showStack_other": "Mostrar rastreo de pila ({{count}} marcos)",
    "hideStack_one": "Ocultar rastreo de pila ({{count}} marco)",
    "hideStack_other": "Ocultar rastreo de pila ({{count}} marcos)"
  },
  "officeMap": {
    "liveHeading": "Live",
    "clients": "Clientes",
    "agents": "Agentes",
    "model": "Modelo",
    "mode": "Modo",
    "toolCalls": "Llamadas",
    "displayHeading": "Visualización",
    "statsHud": "HUD de stats",
    "legends": "Leyendas",
    "minimap": "Minimapa",
    "zoomControls": "Controles de zoom",
    "animateWires": "Animar cables",
    "backgroundHeading": "Fondo",
    "bgDots": "Puntos",
    "bgLines": "Líneas",
    "bgCross": "Cruz",
    "bgNone": "Ninguno"
  },
  "toolInput": {
    "noParams": "(sin parámetros)",
    "itemCount_one": "{{count}} elemento",
    "itemCount_other": "{{count}} elementos",
    "keyCount_one": "{{count}} clave",
    "keyCount_other": "{{count}} claves"
  },
  "message": {
    "roleYou": "Tú",
    "roleTool": "Herramienta",
    "roleThinking": "Pensando",
    "roleAssistant": "Asistente",
    "inputLabel": "Entrada",
    "downloadTitle": "Descargar como archivo",
    "empty": "(vacío)",
    "hideDetails": "Ocultar detalles",
    "showDetails": "Mostrar detalles",
    "showDetailsLines_one": "Mostrar detalles ({{count}} línea)",
    "showDetailsLines_other": "Mostrar detalles ({{count}} líneas)",
    "editHint": "⌘/Ctrl+Enter para guardar · Esc para cancelar",
    "saveResend": "Guardar y reenviar",
    "thinkingProcess": "Proceso de pensamiento",
    "thinkingMeta": "iter {{iter}} · {{dur}} · {{lines}}",
    "replay": "repetición",
    "linesSuffix_one": "{{count}} línea",
    "linesSuffix_other": "{{count}} líneas",
    "copyLog": "Copiar registro",
    "showFullLog": "Mostrar registro completo",
    "typing": "Escribiendo…",
    "noContent": "Sin contenido",
    "failedToSend": "⚠ Error al enviar",
    "autoPaused": "⚠️ _Avance automático en pausa — alcanzado el máximo de turnos automáticos consecutivos. Escribe algo para continuar (la autonomía permanece activa)._",
    "rsIterations": "Iteraciones: {{n}}",
    "rsTools": "Llamadas: {{n}}",
    "rsElapsed": "Transcurrido: {{s}}",
    "rsCost": "Coste: {{c}}",
    "useInput": "Entrada: {{n}}",
    "useOutput": "Salida: {{n}}",
    "useCacheRead": "Lectura cache: {{n}}",
    "useCost": "Coste: {{c}}",
    "renderedLabel": "Renderizado",
    "rawLabel": "Raw",
    "showRenderedTitle": "Mostrar markdown renderizado",
    "showRawTitle": "Mostrar fuente markdown pura",
    "editTitle": "Editar y reenviar este prompt",
    "editLabel": "Editar",
    "unpinTitle": "Desfijar",
    "pinTitle": "Fijar esta respuesta",
    "pinnedLabel": "Fijado",
    "pinLabel": "Fijar",
    "regenerateTitle": "Regenerar esta respuesta",
    "retryLabel": "Reintentar"
  },
  "watch": {
    "toolFallback": "herramienta",
    "toolFailed": "Herramienta fallida"
  },
  "shortcuts": {
    "heading": "Atajos de teclado",
    "footerPre": "Pulsa",
    "footerPost": "en cualquier momento para reabrir esta lista.",
    "sectionGlobal": "Global",
    "sectionTuiParity": "Paridad de panel TUI",
    "sectionFleet": "Flota y agentes",
    "sectionChatInput": "Entrada del chat",
    "sectionChat": "Chat",
    "sectionChatNav": "Navegación del chat (al no escribir)",
    "dCommandPalette": "Abrir paleta de comandos",
    "dShowOverlay": "Mostrar este overlay de atajos",
    "dToggleSidebar": "Alternar barra lateral",
    "dOpenPanel": "Abrir panel lateral (Sesión, Agentes, Historial, Archivos, Cambios, Buzón, Skills, Office Map)",
    "dDesignStudio": "Abrir panel de Design Studio",
    "dWorktrees": "Abrir panel de Worktrees",
    "dFocusInput": "Focalizar la entrada de mensajes",
    "dSessionPanel": "Panel de sesión",
    "dFleetOverlay": "Overlay del monitor de flota",
    "dAgentsOverlay": "Overlay del monitor de agentes",
    "dWorktreeMonitor": "Monitor de worktrees",
    "dPlanPanel": "Panel de plan",
    "dTodosPanel": "Panel de tareas",
    "dQueuePanel": "Panel de cola",
    "dProcessMonitor": "Monitor de procesos",
    "dGoalPanel": "Panel de objetivo",
    "dSessionsDashboard": "Panel de sesiones",
    "dOfficeMap": "Office map del coordinador",
    "dDockPicker": "Selector de chips del dock",
    "dOpenFleet": "Abrir overlay del monitor de flota",
    "dOpenAgents": "Abrir overlay del monitor de agentes",
    "dNavigateAgents": "Navegar agentes en el monitor",
    "dSelectAgent": "Seleccionar agente focalizado",
    "dCloseOverlay": "Cerrar overlay activo",
    "dSendMessage": "Enviar mensaje",
    "dNewline": "Insertar salto de línea",
    "dRecallPrev": "Recuperar prompt anterior (entrada vacía)",
    "dRecallNext": "Recuperar prompt siguiente",
    "dSlashPopup": "Abrir popup de comandos slash",
    "dAutocomplete": "Autocompletar comando resaltado",
    "dDismissPopup": "Cerrar popup / limpiar entrada",
    "dSearchChat": "Buscar en el chat actual",
    "dClearContext": "Limpiar contexto (igual que /clear)",
    "dNewSession": "Iniciar nueva sesión (igual que /new)",
    "dExportMarkdown": "Exportar chat como markdown",
    "dModelSwitcher": "Overlay selector rápido de modelo",
    "dCompactDensity": "Alternar densidad UI compacta",
    "dAbortRun": "Abortar el run actual (durante ejecución)",
    "dFocusNext": "Focalizar mensaje siguiente (alias: ↓)",
    "dFocusPrev": "Focalizar mensaje anterior (alias: ↑)",
    "dJumpFirst": "Ir al primer mensaje",
    "dJumpLast": "Ir al último mensaje",
    "dCopyFocused": "Copiar texto del mensaje focalizado",
    "dClearFocused": "Borrar mensaje focalizado"
  },
  "sddBoard": {
    "titleFallback": "Board SDD en vivo",
    "defaultModelTitle": "Modelo worker por defecto del run (los overrides por tarea tienen prioridad)",
    "graphLabel": "Grafo",
    "kanbanLabel": "Kanban",
    "retryAllTitle": "Volver a poner cada tarea fallida en pending",
    "retryFailed": "Reintentar fallidas ({{count}})",
    "resume": "Reanudar",
    "pause": "Pausar",
    "stop": "Detener",
    "cleanTitle": "Eliminar los worktrees git + ramas wstack/ap del run",
    "cleanWorktrees": "Limpiar worktrees",
    "rollbackTitle": "Revertir {{count}} commit(s) mergeado(s) en {{base}}",
    "rollback": "Rollback ({{count}})",
    "stopping": "Deteniendo…",
    "destroying": "Destruyendo…",
    "destroyTitle": "Detener, eliminar todos los worktrees, revertir opcionalmente los commits mergeados y borrar el proyecto SDD",
    "destroy": "Destruir",
    "statDone": "hechos",
    "statRunning": "en curso",
    "statFailed": "fallidos",
    "statWave": "oleada",
    "statElapsed": "transcurrido",
    "noActiveWorkers": "sin workers activos",
    "deadlock": "Interbloqueo — tareas bloqueadas por trabajo fallido:",
    "noRunTitle": "Sin run SDD activo.",
    "noRunBody": "Inicia uno desde el asistente New SDD Project o vía /sdd execute en la CLI — los agentes aparecen aquí en vivo, cada uno en un worktree aislado.",
    "clickTaskHint": "clic en una tarea para detalles",
    "lcClean": "Limpieza",
    "lcRollback": "Rollback",
    "lcDestroy": "Destrucción",
    "lcFailed": "{{op}} falló: {{reason}}",
    "lcUnknownError": "error desconocido",
    "lcWorktrees_one": "{{count}} worktree eliminado",
    "lcWorktrees_other": "{{count}} worktrees eliminados",
    "lcCommits_one": "{{count}} commit revertido",
    "lcCommits_other": "{{count}} commits revertidos",
    "lcDeleted": "borrado {{items}}",
    "lcNothing": "nada que hacer",
    "lcNote": "{{op}}: {{body}} — nota: {{reason}}",
    "lcOk": "{{op}}: {{body}}"
  },
  "sddTask": {
    "backTitle": "Volver a la actividad",
    "workingOn": "trabajando en esta tarea",
    "assigned": "asignado",
    "metaPriority": "Prioridad",
    "metaType": "Tipo",
    "metaDuration": "Duración",
    "metaElapsed": "Transcurrido",
    "metaRetries": "Reintentos",
    "metaWorktree": "Worktree",
    "workerModel": "Modelo worker",
    "runDefault": "predeterminado del run: {{model}}",
    "runDefaultPlaceholder": "Predeterminado del run",
    "runDefaultPlaceholderModel": "Predeterminado del run ({{model}})",
    "verificationCmd": "Comando de verificación",
    "gatesCompletion": "valida la finalización (exit 0)",
    "verifyPlaceholder": "ej. pnpm vitest run path/to/file",
    "addVerify": "+ Añadir comando de verificación",
    "description": "Descripción",
    "timeline": "Cronología",
    "dependsOn": "Depende de",
    "blocks": "Bloquea",
    "newWorkerPlaceholder": "Nombre del nuevo worker…",
    "confirmStop": "¿Detener esta tarea en ejecución?",
    "confirmDelete": "¿Eliminar esta tarea del run?",
    "retryTitle": "Volver a poner esta tarea en pending",
    "reassign": "Reasignar",
    "stopTitle": "Abortar el worker en esta tarea",
    "splitTitle": "Dividir esta tarea en subtareas delegadas a workers separados",
    "split": "Dividir",
    "splitHint": "Una subtarea por línea — Título :: descripción (descripción opcional)",
    "splitPlaceholder": "Escribe la capa de datos :: añade el repositorio\nConecta la UI",
    "splitInto": "Dividir en subtareas",
    "deleteTitle": "Quitar esta tarea no iniciada del run"
  },
  "sddWizard": {
    "phaseStart": "Iniciar",
    "phaseInterview": "Entrevista",
    "phaseSpecReview": "Revisión spec",
    "phasePlanning": "Planificación",
    "phaseTaskReview": "Revisión tareas",
    "phaseRunning": "En ejecución",
    "phaseDone": "Completado",
    "titleFallback": "Nuevo proyecto SDD",
    "questionsSuffix": "{{cur}}/{{max}} preguntas",
    "tasksSuffix": "{{count}} tareas",
    "runCfgTitle": "Config del run — modelo por defecto + cadena de respaldo",
    "modelsLabel": "Modelos",
    "startRun": "Iniciar run",
    "defaultWorkerModel": "Modelo worker por defecto",
    "leaderDefaultPlaceholder": "Leader / defecto de sesión",
    "useSessionDefault": "Usar defecto de sesión",
    "fallbackChain": "Cadena de respaldo",
    "appliesToAll": "Se aplica a cada tarea. Override por tarea desde el board live tras iniciar.",
    "parallelAgents": "Agentes paralelos",
    "isolateWorktrees": "Aislar en worktrees git",
    "worktreeOn": "Cada tarea corre en su propio worktree, squash-mergeado al completar.",
    "worktreeOff": "Las tareas corren directamente en la rama actual (sin aislamiento).",
    "goalPrompt": "¿Qué quieres construir?",
    "goalPlaceholder": "ej. Añadir login OAuth (Google + GitHub) con gestión de sesión",
    "startingInterview": "Iniciando entrevista…",
    "startInterview": "Iniciar entrevista",
    "introBody": "Un agente aislado te entrevista para construir una spec, la descompone en un grafo de tareas ordenado por dependencias, luego una flota multi-agente real lo ejecuta — síguelo en vivo en el board.",
    "taskGraphSummary": "Grafo de tareas · {{count}} tareas, ordenadas por dependencias",
    "dragToExplore": "arrastra para explorar",
    "show": "mostrar",
    "goalLabel": "Objetivo",
    "implementationPlan": "Plan de implementación",
    "approveSpec": "Aprobar spec → planificar implementación",
    "approveTasks": "Aprobar tareas",
    "approvePlan": "Aprobar plan",
    "answerPlaceholder": "Responde a la pregunta…",
    "changePlaceholder": "Pedir un cambio…"
  },
  "fileExplorer": {
    "emptyDir": "vacío",
    "loadFailed": "Error al cargar archivos: {{error}}",
    "expandAllTitle": "Expandir todas las carpetas",
    "expandAll": "Expandir todo",
    "collapseAllTitle": "Contraer todas las carpetas",
    "collapse": "Contraer",
    "folders_one": "{{count}} carpeta",
    "folders_other": "{{count}} carpetas",
    "currentDirTitle": "Directorio actual: {{path}}",
    "navigateToTitle": "Navegar a {{path}}",
    "filesSuffix_one": "{{count}} archivo",
    "filesSuffix_other": "{{count}} archivos",
    "goToDir": "ir al directorio",
    "navigateParentTitle": "Navegar al directorio padre de {{path}}",
    "parentDirectory": "directorio padre",
    "noFiles": "No se encontraron archivos",
    "copyAbsPath": "Copiar ruta absoluta",
    "copyRelPath": "Copiar ruta relativa",
    "openInTerminal": "Abrir en terminal",
    "openInFileManager": "Abrir en gestor de archivos",
    "mentionInChat": "Mencionar en el chat",
    "copyPath": "Copiar ruta"
  },
  "codeEditor": {
    "sendSelectionAction": "Enviar selección al chat",
    "noFilesOpen": "Sin archivos abiertos",
    "selectToEdit": "Selecciona un archivo del explorador para editar",
    "sendSelectedTitle": "Enviar líneas seleccionadas al chat",
    "mentionFileTitle": "Mencionar este archivo en el chat",
    "sendToChat": "Enviar al chat",
    "mentionFile": "Mencionar archivo",
    "loadingEditor": "Cargando editor…",
    "selectTab": "Selecciona una pestaña para ver su contenido"
  },
  "analytics": {
    "loading": "Cargando analíticas…",
    "heading": "Panel de analíticas",
    "autoRefresh": "actualización cada 10 s",
    "liveSessions": "Sesiones en vivo",
    "agents": "Agentes",
    "agentsActive": "{{count}} activos",
    "totalEvents": "Eventos totales",
    "categoriesSub": "{{count}} categorías",
    "toolCalls": "Llamadas",
    "iterationsSub": "{{count}} iteraciones",
    "sessionCost": "Coste de sesión",
    "tokensSub": "{{input}} entrada / {{output}} salida",
    "sessionDuration": "Duración de sesión",
    "messagesSub": "{{count}} mensajes",
    "eventsByCategory": "Eventos por categoría",
    "noEvents": "Aún no hay eventos registrados.",
    "topEvents": "Eventos principales",
    "activeSessionUsage": "Uso de sesión activa",
    "provider": "Proveedor",
    "model": "Modelo",
    "inputTokens": "Tokens de entrada",
    "outputTokens": "Tokens de salida",
    "cacheRatio": "Ratio de caché",
    "filesRead": "Archivos leídos",
    "noSession": "Sin sesión activa o esperando datos…",
    "healthErrors": "Salud y errores",
    "errorEvents": "Eventos de error",
    "warningEvents": "Eventos de aviso",
    "cacheHitRate": "Tasa de aciertos de caché",
    "totalCategories": "Categorías totales",
    "waitingData": "Esperando datos…",
    "recentEvents": "Eventos recientes",
    "noRecentEvents": "Sin eventos recientes. Interactúa con la UI para generar eventos."
  },
  "promptLib": {
    "searchPlaceholder": "Buscar prompts…",
    "newPrompt": "＋ Nuevo prompt",
    "all": "Todos",
    "recent": "🕘 Recientes",
    "favorites": "★ Favoritos",
    "noMatch": "Ningún prompt coincide.",
    "newPromptHeading": "Nuevo prompt",
    "titlePlaceholder": "Título *",
    "descPlaceholder": "Descripción de una línea",
    "categoryPlaceholder": "Categoría",
    "tagsPlaceholder": "etiquetas, separadas, por coma",
    "contentPlaceholder": "Contenido del prompt * — usa {{name}} para variables",
    "variables": "Variables",
    "addVar": "＋ var",
    "varNamePlaceholder": "nombre",
    "varDescPlaceholder": "descripción",
    "removeVarTitle": "Eliminar variable",
    "required": "obligatorio",
    "multiline": "multilínea",
    "enumPlaceholder": "enum: a, b, c",
    "savePrompt": "Guardar prompt",
    "saveFailed": "No se pudo guardar el prompt.",
    "titleContentRequired": "El título y el contenido son obligatorios.",
    "toggleFavoriteTitle": "Alternar favorito",
    "selectOption": "— elegir —",
    "fillMissing": "Rellenar: {{missing}}",
    "insertIntoChat": "Insertar en el chat",
    "selectPromptHint": "Selecciona un prompt para previsualizar e insertar."
  },
  "skillDetail": {
    "scopeProject": "Proyecto",
    "scopeGlobal": "Global",
    "scopeBundled": "Integrado",
    "timeoutError": "Tiempo de espera agotado. Inténtalo de nuevo.",
    "updateFailed": "Actualización fallida",
    "saveFailed": "Guardado fallido",
    "uninstallFailed": "Desinstalación fallida",
    "noSkillSelected": "Ninguna habilidad seleccionada",
    "selectSkillHint": "Selecciona una habilidad de la barra lateral para ver su documentación",
    "goToChat": "Ir al chat",
    "openSourceRepo": "Abrir repo de origen",
    "copySourceUrl": "Copiar URL de origen",
    "updatedLabel": "↑ Actualizado: {{list}}",
    "upToDateLabel": "— Actualizado: {{list}}",
    "errorsLabel": "✗ {{list}}",
    "checkUpdatesTitle": "Buscar actualizaciones",
    "exportTitle": "Exportar habilidad como .md",
    "editTitle": "Editar habilidad",
    "uninstallTitle": "Desinstalar habilidad",
    "closeTitle": "Cerrar e ir al chat",
    "backTitle": "Atrás",
    "forwardTitle": "Adelante",
    "relatedFiles": "Archivos relacionados",
    "references": "Referencias",
    "goToSkillTitle": "Ir a {{name}}",
    "loadingContent": "Cargando contenido…",
    "editingLabel": "Editando {{name}}",
    "editStats": "{{lines}} líneas · {{words}} palabras · {{chars}} caracteres",
    "charsWarningFmt": "⚠ {{used}} MB / {{limit}} MB",
    "draftSaved": "Borrador guardado",
    "draftRestored": "Borrador restaurado",
    "discardDraft": "Descartar borrador",
    "splitViewTitle": "Vista dividida",
    "hidePreviewTitle": "Ocultar vista previa",
    "contentPlaceholder": "Contenido de la habilidad (markdown)...",
    "loadFailed": "Error al cargar el contenido",
    "noContent": "Sin contenido disponible",
    "uninstallSkillHeading": "Desinstalar habilidad",
    "uninstallConfirm": "¿Desinstalar {{name}}?",
    "uninstallRemovePath": "Esto eliminará la habilidad de {{path}} y no se puede deshacer.",
    "uninstallAction": "Desinstalar"
  },
  "office": {
    "sessionStats": "Estadísticas de sesión",
    "clients": "Clientes",
    "input": "Entrada",
    "output": "Salida",
    "cost": "Coste",
    "agentsSuffix": "agentes",
    "upPrefix": "activo {{time}}",
    "webuiClient": "Cliente WebUI",
    "disconnected": "Desconectado",
    "connected": "Conectado",
    "tuiClient": "Cliente TUI",
    "terminal": "Terminal",
    "repl": "REPL",
    "coordinator": "COORDINADOR",
    "fleetSummary": "Resumen de flota",
    "toolCallsLabel": "Llamadas",
    "tokensLabel": "Tokens",
    "coordinatingFleet": "Coordinando flota",
    "donePrefix": "✓ hecho ·",
    "failedPrefix": "✕ fallido ·",
    "seenPrefix": "visto hace {{time}}",
    "availableDesk": "Escritorio disponible",
    "mailboxHub": "Centro de correo",
    "unreadSuffix_one": "{{count}} sin leer",
    "unreadSuffix_other": "{{count}} sin leer",
    "allClear": "Todo leído",
    "total": "Total",
    "unreadLabel": "Sin leer",
    "liveActivity": "Actividad en vivo",
    "waitingActivity": "Esperando actividad…",
    "now": "ahora",
    "fleetHq": "Cuartel General de Flota WrongStack",
    "live": "EN VIVO",
    "legendStatus": "Estado",
    "legendActive": "Activo",
    "legendIdle": "Inactivo",
    "legendError": "Error",
    "legendConnections": "Conexiones",
    "legendMail": "Correo",
    "legendTask": "Tarea",
    "legendStatusConn": "Estado",
    "arrange": "Organizar",
    "arrangeTitle": "Volver los nodos al plano",
    "feed": "Feed",
    "feedTitle": "Alternar el feed de actividad en vivo",
    "broadcast": "Difundir",
    "broadcastTitle": "Difundir un mensaje a cada sesión en vivo del proyecto",
    "broadcastToAll": "Difundir a todas las sesiones",
    "broadcastPlaceholder": "Mensaje a cada agente en vivo del proyecto…",
    "broadcastSendHint": "⌘/Ctrl+Enter para enviar",
    "openFullView": "Abrir vista completa de operaciones",
    "rowStatus": "Estado",
    "rowModel": "Modelo",
    "rowTool": "Herramienta",
    "rowIterations": "Iteraciones",
    "rowToolCalls": "Llamadas",
    "rowTokensIn": "Tokens entrada",
    "rowTokensOut": "Tokens salida",
    "rowTokensTotal": "Tokens totales",
    "rowContext": "Contexto",
    "rowCost": "Coste",
    "rowLastSeen": "Visto por última vez",
    "rowSurface": "Superficie",
    "rowBranch": "Rama",
    "rowPid": "PID",
    "rowDir": "Dir.",
    "rowAgents": "Agentes",
    "rowUptime": "Tiempo activo",
    "rowConnections": "Conexiones",
    "rowTotalMessages": "Mensajes totales",
    "rowUnread": "Sin leer",
    "recent": "Recientes",
    "noSubject": "(sin asunto)",
    "fullOperationStream": "Flujo completo de operaciones",
    "closeEsc": "Cerrar (Esc)",
    "idleDesk": "Escritorio inactivo",
    "fleetHqLabel": "Cuartel General de Flota",
    "clientsSuffix_one": "{{count}} cliente",
    "clientsSuffix_other": "{{count}} clientes",
    "taskFallback": "tarea",
    "controlLabel": "control"
  },
  "skillsList": {
    "installTitle": "Instalar habilidad",
    "createTitle": "Crear habilidad",
    "exportTitle": "Exportar todas las habilidades como .zip",
    "checkUpdatesTitle": "Buscar actualizaciones (todas)",
    "searchPlaceholder": "Buscar habilidades…",
    "loading": "Cargando…",
    "noSkills": "Sin habilidades instaladas",
    "noMatch": "Ninguna habilidad coincide con el filtro",
    "noDescription": "Sin descripción",
    "scopeForeign": "Externa",
    "installHeading": "Instalar Habilidad",
    "installHint": "Introduce una referencia de repo GitHub (owner/repo) o URL completa.",
    "installPlaceholder": "ej. wrongstack/skill-name o https://github.com/owner/repo",
    "installScope": "Ámbito de instalación:",
    "installBtn": "Instalar",
    "installedMsg": "Instalada: {{names}}",
    "installFailed": "Instalación fallida",
    "createHeading": "Crear Habilidad",
    "createHint": "Scaffold una nueva habilidad. La primera línea es el trigger.",
    "nameLabel": "Nombre",
    "namePlaceholder": "ej. mi-nueva-habilidad",
    "descLabel": "Descripción / Trigger",
    "descPlaceholder": "Usa esta habilidad cuando <situación>.\nTriggers: el usuario dice \"palabra clave\", \"otra\".",
    "saveIn": "Guardar en:",
    "createBtn": "Crear Habilidad",
    "createdMsg": "Creada: {{name}}",
    "createFailed": "Creación fallida"
  },
  "timeline": {
    "noEvents": "Sin eventos."
  },
  "designStudio": {
    "pickHint": "Elige un kit — el agente se ceñirá a él.",
    "gallery": "Galería",
    "galleryTitle": "Abrir galería de vista previa en vivo",
    "stackTitle": "Stack objetivo",
    "loading": "Cargando kits…",
    "notFound": "No se encontraron kits de diseño.",
    "bestFor": "Ideal para:",
    "light": "Claro",
    "dark": "Oscuro"
  },
  "worktrees": {
    "detached": "(separado)",
    "count_one": "{{count}} worktree",
    "count_other": "{{count}} worktrees",
    "baseSuffix": " · base {{base}}",
    "baseLabel": "base",
    "cleanOrphans": "Limpiar huérfanos",
    "cleanOrphansTitle": "Eliminar todos los worktrees huérfanos",
    "liveBusyTitle": "Un run está activo — deténlo primero",
    "rescanTitle": "Re-escanear",
    "removed_one": "Eliminado {{count}} worktree.",
    "removed_other": "Eliminados {{count}} worktrees.",
    "failed": "Falló",
    "mergedIntoBase": "{{branch}} fusionado en la base.",
    "conflictMerge": "Conflicto al fusionar {{branch}}: {{files}}",
    "seeGit": "ver git",
    "mergeFailed": "Fusión fallida: {{reason}}",
    "unknownReason": "desconocido",
    "mergeConfirmTitle": "¿Fusionar {{branch}} en {{base}}?",
    "mergeConfirmMsg": "Squash-fusiona este branch al branch base. Se cancela limpiamente si hay conflicto.",
    "mergeAction": "Fusionar",
    "removeConfirmTitle": "¿Eliminar {{branch}}?",
    "removeConfirmMsg": "Elimina forzosamente el checkout del worktree y borra su branch. El trabajo sin fusionar se descarta.",
    "empty": "Sin worktrees.",
    "emptyHint": "Los runs SDD / AutoPhase crean worktrees aislados aquí. Los huérfanos de runs caídos también aparecen.",
    "actOpenTerm": "Abrir en terminal",
    "actOpenFolder": "Abrir carpeta",
    "actViewChanges": "Ver cambios",
    "actMerge": "Fusionar a la base",
    "actRemove": "Eliminar / descartar",
    "live": "activo",
    "noUncommitted": "Sin cambios sin confirmar",
    "commitsAhead_one": "{{count}} commit adelante",
    "commitsAhead_other": "{{count}} commits adelante",
    "more": "…{{count}} más"
  },
  "officeSettings": {
    "heading": "Mapa de Oficina",
    "headingHint": "Visualiza tu flota como un plano de oficina con el estado de los agentes en vivo.",
    "statAgents": "Agentes",
    "statMail": "Correo",
    "unreadSuffix": " sin leer",
    "sectionView": "Vista",
    "sectionDisplay": "Visualización",
    "sectionBackground": "Fondo",
    "sectionRecent": "Actividad Reciente",
    "eventsTrackedSuffix": " eventos rastreados",
    "recentHint": "Envíos de correo, spawns de agentes y cambios de estado aparecen aquí.",
    "sectionShortcuts": "Atajos",
    "sectionLegend": "Leyenda",
    "hudLabel": "HUD",
    "hudDesc": "Mostrar overlay de estadísticas de sesión en tiempo real",
    "hudToggle": "Activar HUD",
    "minimapLabel": "Minimapa",
    "minimapDesc": "Mostrar el minimapa de resumen",
    "minimapToggle": "Activar minimapa",
    "controlsLabel": "Controles",
    "controlsDesc": "Mostrar controles de zoom y ajuste",
    "controlsToggle": "Activar controles",
    "animateLabel": "Animar aristas",
    "animateDesc": "Animar el flujo en conexiones activas",
    "animateToggle": "Activar animación de aristas",
    "legendLabel": "Mostrar leyenda",
    "legendDesc": "Mostrar leyenda de estado y conexión",
    "legendToggle": "Activar leyenda",
    "feedLabel": "Feed en vivo",
    "feedDesc": "Banda inferior de actividad reciente entre procesos",
    "feedToggle": "Activar feed en vivo",
    "fitView": "Ajustar",
    "zoomIn": "Acercar",
    "zoomOut": "Alejar",
    "resetZoom": "Reiniciar zoom",
    "legendActive": "Activo (en ejecución)",
    "legendIdle": "Inactivo",
    "legendError": "Error",
    "legendOffline": "Desconectado",
    "bg": {
      "dots": "Puntos",
      "lines": "Líneas",
      "cross": "Cruz",
      "none": "Ninguno"
    }
  }
}
